import type { QuantitySelectorSize, QuantitySelectorVariant } from 'components/common/QuantitySelector/QuantitySelector.types';

export const containerBaseClasses = 'flex justify-between items-center border-solid border gap-x-1 rounded-sm';

export const containerSizeClasses: Record<QuantitySelectorSize, string> = {
  large: 'w-fit px-[24px] py-[10px]',
  small: 'w-fit px-[10px] py-[8px]'
};

export const containerVariantClasses: Partial<Record<QuantitySelectorVariant, string>> = {
  base: 'border-gray-300',
  disabled: 'border-button-disabled',
  empty: 'border-button-moderate',
  error: 'border-alert'
};

export const iconVariantClasses: Partial<Record<QuantitySelectorVariant, string>> = {
  disabled: 'text-icon-disabled'
};

export const countBaseClasses = 'font-semibold border-none bg-button-transparent text-center w-full min-w-[20px] md:w-[20px]';

export const countSizeClasses: Record<QuantitySelectorSize, string> = {
  large: 'body-m',
  small: 'body-s'
};

export const countVariantClasses: Partial<Record<QuantitySelectorVariant, string>> = {
  disabled: 'text-disabled'
};

export const wrapperClasses = 'flex flex-col gap-y-1';
export const errorContainerClasses = 'flex gap-x-2';
export const errorClasses = 'text-icon-alert';
export const errorTextClasses = 'body-xs';
